export const comments_3389030 = {"data":{"data":[],"links":{}}}